import { Component, Input, Injector } from '@angular/core';
import { Events } from 'ionic-angular';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'rispostarating_9',
  templateUrl: 'rispostarating_9.html',
})

export class RispostaRating_9Component extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  output: any;
  risposte_conferma: any = [];
  showconferma: boolean = true;
  feed = '';
  risp: any;
  showfeed: boolean = false;
  showtime: boolean = true;
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';

  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('rispostarating', this.domanda, this.risposte_conferma);
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
      let r = this.domanda['RispostaMicroStepList'][i];
      var hradio = document.getElementById('item_' + r.id).clientHeight;
      var radio_icon = document.getElementById(r.id).children[0];
      radio_icon.setAttribute("style", "height:" + hradio + "px !important");
      radio_icon.children[0].setAttribute("style", "height:" + (hradio - 22) + "px !important");
    }
  }

  sel(r) {
    let ris = [];
    ris[0] = r.id;
    //this.update_output(ris);
    this.risposte_conferma = ris;
  }

  changestyle(esatte, errate) {

    var x = document.getElementsByTagName("ion-radio");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];

      if (esatte.indexOf(l['id']) != -1) {
        //l.children[0].children[0].classList.add('baffo');
        l.children[0].classList.add('green');
      }
      if (errate.indexOf(l['id']) != -1) {
        l.children[0].classList.add('red');
        l.children[0].children[0].classList.add('baffox');
      }
    }
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.events.publish('start_tempo', this.domanda);
    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
  }

  conferma(tempo?) {
    this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
      if (this.risposte_conferma.length == 0 && tempo != 'tempo') {
        // this.feed = 'Non hai inserito nessuna risposta';
        // this.showfeed = true;

        this.presentToast(v);
        return;

      }
      this.events.publish('stop_tempo_parziale', this.domanda);
      //console.log(this.risposte_conferma);
      let risp_esatte = [];
      let risp_errate = [];
      let r_esatte = [];
      for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
        let r = this.domanda['RispostaMicroStepList'][i];
        if (r.punti > 0)
          r_esatte.push(r.id);
      }
      for (let i = 0; i < this.risposte_conferma.length; i++) {
        let rdata = this.risposte_conferma[i];

        if (r_esatte.indexOf(rdata) == -1) {
          risp_errate.push(rdata);
        }
      }
      //console.log('esatte', risp_esatte);
      //console.log('errate', risp_errate);
      //this.changestyle(r_esatte, risp_errate);


      if (risp_errate.length == 0 && this.risposte_conferma.length > 0)
        this.feed = this.domanda['feedbackPositivo'];
      else
        this.feed = this.domanda['feedbackNegativo'];
      this.showconferma = false;
      this.showfeed = true;
      if (this.settingsmq['istest'])
        this.prosegui();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/rispostarating_9.ts